import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ResumeBox from "./components/ResumeBox";
import {ResumeBoxItem} from "./components/ResumeBoxItem";
import {chileCurrency} from "presentation/common/helpers/utils";
import Feature from "presentation/common/components/style-guide/pricing/Feature";
import styles from './Resume.module.scss';
// icons
import {Checkbox, formatPhone, ModalHelper} from "presentation/common";
import {TermAndConditionsContent} from "presentation/common/components/style-guide/modal";
import {BillIcon, UserIcon, PlanIcon, PaymentIcon} from "presentation/common/components/style-guide/icons";

export const Resume = ({uiState, dataState, onChangeAcceptTermAndConditionsAction}) => {
  const {billInfo} = dataState;

  const openTermAndConditions = useCallback(() => {
    ModalHelper.open("TÉRMINOS Y CONDICIONES", TermAndConditionsContent)
  }, []);

  return (
    <>
      <div className="flex flex-wrap flex-auto py-3 overflow-y-auto">
        <ResumeBox icon={PlanIcon} title="SERVICIOS SELECCIONADOS">
          <ul className="mt-4 space-y-2">
            {
              dataState.planSelected && dataState.planSelected.items.map(item => <Feature title={item.title} key={item.id} isCompact={true}/>)
            }
          </ul>
        </ResumeBox>

        <ResumeBox icon={UserIcon} title="DATOS PERSONALES">
          <ResumeBoxItem label="RUT" value={dataState.rut}/>
          <ResumeBoxItem label="Nombre y Apellidos" value={`${dataState.name} ${dataState.firstName} ${dataState.lastName}`}/>
          <ResumeBoxItem label="Correo Electrónico" value={dataState.email}/>
          <ResumeBoxItem label="Teléfono" value={`${formatPhone(dataState.phone, dataState.countryCode)}`}/>
        </ResumeBox>

        {
          billInfo.rut &&
          <ResumeBox icon={BillIcon} title="DATOS FACTURACIÓN">
            <ResumeBoxItem label="RUT" value={billInfo.rut}/>
            <ResumeBoxItem label="Razón Social" value={billInfo.businessType}/>
            <ResumeBoxItem label="Actividad Económica" value={billInfo.economicActivity}/>
            <ResumeBoxItem label="Dirección" value={billInfo.address}/>
          </ResumeBox>
        }

        <ResumeBox icon={PaymentIcon} title="DATOS DEL PAGO">
          <ResumeBoxItem label="Forma de Pago" value={dataState.paymentType}/>
          <ResumeBoxItem label="Comprobante de pago" value={billInfo.rut ? 'Factura' : 'Boleta'}/>
          <ResumeBoxItem label="Monto" value={chileCurrency(dataState.planSelected?.price || 0)}/>
        </ResumeBox>
      </div>

      <div className={clsx('p-3 m-0 flex')}>
        <Checkbox
          className={styles.termAndConditionContainer}
          value={true}
          checked={uiState.acceptTermAndConditions}
          onChange={(v) => onChangeAcceptTermAndConditionsAction(v.target.checked)}/>

          <p className={styles.termAndCondition}>Debe marcar los
            <span role="button" tabIndex={-1} onClick={openTermAndConditions}> Términos y Condiciones </span> para poder efectuar el pago.
          </p>
      </div>
    </>
  );
};

Resume.propTypes = {
  uiState: PropTypes.object,
  dataState: PropTypes.object
}

Resume.defaultProps = {}

export default Resume;
